import React from 'react'
/** @jsxImportSource @emotion/react */

import { convertHoursInMinutes, formatMinutesInHours } from '../_helpers/pdfHelpers'
import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import Text from '../../../../components/pdf/Text'
import Grid from '../../../../components/pdf/Grid'

const ServiceTable = ({ style, services }) => {
  const sumOfficeHours = services.reduce((total, service) => total + service.officeHour, 0)
  const sumServiceHoursInMinutes = services.reduce((total, service) => total + service.totalOfHoursInMinutes, 0)
  const officeHoursInMinutes = convertHoursInMinutes(sumOfficeHours)

  return (
    <>
      <Grid justify="center" style={{ padding: '0.5rem 1rem' }}>
        <Table width="100%" center style={{ border: '2px solid #333' }} color="#000">
          <TableRow style={{ backgroundColor: '#a6a6a6' }} color="#000">
            <TableCol color="#000">
              <Text bold size="small" align="right" color="#000">
                OBRA:
              </Text>
            </TableCol>
            <TableCol colspan={8} color="#000">
              <Text bold size="small" align="center">
                {services[0].place}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow style={{ backgroundColor: '#a6a6a6' }} color="#000">
            <TableCol>
              <Text bold size="small" align="center">
                Data
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Equipe
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Serviço prestado
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Descrição do serviço
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Início
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Término
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Início2
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text bold size="small" align="center">
                Término2
              </Text>
            </TableCol>
            <TableCol color="#000" width="8%">
              <Text bold size="small" align="center">
                Total
              </Text>
            </TableCol>
          </TableRow>
          {services.map(item => {
            return (
              <>
                <TableRow css={style}>
                  <TableCol color="#000">
                    <Text size="small" align="center">
                      {item.date}
                    </Text>
                  </TableCol>
                  <TableCol color="#000">
                    <Text size="small" align="center">
                      {item.team}
                    </Text>
                  </TableCol>
                  <TableCol color="#000">
                    <Text size="small" align="center">
                      {item.serviceProvided}
                    </Text>
                  </TableCol>
                  <TableCol color="#000">
                    <Text size="small" align="center">
                      {item.serviceDescription}
                    </Text>
                  </TableCol>
                  <TableCol color="#000">
                    <Text size="small" align="center">
                      {item.startTime}
                    </Text>
                  </TableCol>
                  <TableCol color="#000">
                    <Text size="small" align="center">
                      {item.endTime}
                    </Text>
                  </TableCol>
                  <TableCol color="#000">
                    <Text size="small" align="center">
                      {item.startTime2}
                    </Text>
                  </TableCol>
                  <TableCol color="#000">
                    <Text size="small" align="center">
                      {item.endTime2}
                    </Text>
                  </TableCol>
                  <TableCol color="#000">
                    <Text size="small" align="center">
                      {formatMinutesInHours(item.totalOfHoursInMinutes)}
                    </Text>
                  </TableCol>
                </TableRow>
              </>
            )
          })}

          <TableRow style={{ border: '2px solid #000' }}>
            <TableCol color="#000" colspan={8}>
              <Text size="small" align="center">
                Hora de escritório
              </Text>
            </TableCol>
            <TableCol color="#000">
              <Text size="small" align="center">
                {formatMinutesInHours(officeHoursInMinutes)}
              </Text>
            </TableCol>
          </TableRow>
          <TableRow style={{ border: '2px solid #000' }}>
            <TableCol color="#000" colspan={8}>
              <Text size="small" align="center" bold>
                Total de horas trabalhadas no mês
              </Text>
            </TableCol>
            <TableCol color="#000" style={{ backgroundColor: '#92d050' }}>
              <Text size="small" align="center">
                {formatMinutesInHours(sumServiceHoursInMinutes + officeHoursInMinutes)}
              </Text>
            </TableCol>
          </TableRow>
        </Table>
      </Grid>
    </>
  )
}

export default ServiceTable
